import React from "react";
import { ContainerModal, FooterModal } from "./styles";
import isMobile from "is-mobile";
import { Modal } from "../../modal-base";
import { StyledTypography } from "../../modal-base/modal-header-text/style";
import * as IconMui from "@mui/icons-material";

export interface ModalGenericProps {
  isOpen: boolean;
  toggle: () => void;
  title: string;
  description?: string;
  children: React.ReactNode;
  maxWidth?: string;
  maxHeight?: string;
  primaryAction?: {
    label: string;
    onClick: () => void;
    startIcon?: keyof typeof IconMui;
    color?: string;
    disabled?: boolean;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
    startIcon?: React.ReactNode;
    color?: string;
  };
}

export const ModalGeneric: React.FC<ModalGenericProps> = ({
  isOpen,
  toggle,
  title,
  description,
  children,
  primaryAction,
  secondaryAction,
  maxWidth = "450px",
  maxHeight = "50vh",
}) => {
  return (
    <Modal.Root open={isOpen} onClose={toggle} maxWidth={maxWidth}>
      <Modal.Header>
        <Modal.Icon
          icon="Close"
          cursor="pointer"
          onClick={toggle}
          iconColor="black"
        />
      </Modal.Header>
      <Modal.Content>
        <ContainerModal width={maxWidth}>
          {primaryAction?.startIcon && (
            <Modal.Icon
              icon={primaryAction.startIcon}
              iconColor={primaryAction.color || "#000"}
              circular
              circularColor="#FDF3F2"
              circularBorder={true}
              padding="2px"
            />
          )}
          <StyledTypography
            ownerState={{
              fontSize: isMobile() ? 18 : 24,
              fontWeight: 700,
              color: "#404252",
            }}
          >
            {title}
          </StyledTypography>
          {description && (
            <StyledTypography
              ownerState={{
                color: "#404252",
              }}
              style={{ textAlign: "center" }}
            >
              {description}
            </StyledTypography>
          )}
          <div style={{ marginTop: "16px", width: "100%", height: maxHeight }}>
            {children}
          </div>
          {(primaryAction || secondaryAction) && (
            <FooterModal>
              {primaryAction && (
                <Modal.Button
                  bgColor=""
                  color={primaryAction.color || "primary"}
                  onClick={primaryAction.onClick}
                  disabled={primaryAction.disabled}
                >
                  {primaryAction.label}
                </Modal.Button>
              )}
              {secondaryAction && (
                <Modal.Button
                  bgColor=""
                  color={secondaryAction.color || "default"}
                  onClick={secondaryAction.onClick}
                  startIcon={secondaryAction.startIcon}
                >
                  {secondaryAction.label}
                </Modal.Button>
              )}
            </FooterModal>
          )}
        </ContainerModal>
      </Modal.Content>
    </Modal.Root>
  );
};
